import React from 'react';
import {createRoot} from 'react-dom/client';
import {KatSpinner} from '@amzn/katal-react';

import './app/util/Logger';

import '@amzn/katal-components/styles.css';
import './assets/css/index.scss';
import AppInitWrapper from "src/app/AppInitWrapper";
import App from "src/app/App";
import {BrowserRouter} from "react-router-dom";
import {Amplify} from "aws-amplify";
import {COGNITO_CONFIG, GENERATE_API_ENDPOINTS} from "src/app/config/ApiConfig";
import {isDev} from "src/app/constant/Constants";

Amplify.configure({
    Auth: {
        mandatorySignIn: true,
        region: COGNITO_CONFIG.REGION,
        userPoolId: COGNITO_CONFIG.USER_POOL_ID,
        identityPoolId: COGNITO_CONFIG.IDENTITY_POOL_ID,
        userPoolWebClientId: COGNITO_CONFIG.APP_CLIENT_ID,
        oauth: {
            domain: COGNITO_CONFIG.COGNITO_DOMAIN,
            scope: ['phone', 'email', 'openid', 'aws.cognito.signin.user.admin', 'profile'],
            redirectSignIn: window.location.origin + '/',
            redirectSignOut: window.location.origin + '/',
            responseType: 'code',
            options: {
                AdvancedSecurityDataCollectionFlag: false,
            },
        }
    },
    Analytics: {
        disabled: true
    },
    API: {
        endpoints: GENERATE_API_ENDPOINTS()
    }
});

const container = document.getElementById('root');
const root = createRoot(container!);
if (isDev()) {
    root.render(
        <React.StrictMode>
            <AppInitWrapper>
                <React.Suspense fallback={<KatSpinner size="large"/>}>
                    <BrowserRouter>
                        <App/>
                    </BrowserRouter>
                </React.Suspense>
            </AppInitWrapper>
        </React.StrictMode>
    );
} else {
    root.render(
        <AppInitWrapper>
            <React.Suspense fallback={<KatSpinner size="large"/>}>
                <BrowserRouter>
                    <App/>
                </BrowserRouter>
            </React.Suspense>
        </AppInitWrapper>
    );
}
